module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card",
    class: {
      shake: _vm.error
    },
    attrs: {
      "id": "login"
    }
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "name": "login_form"
    }
  }, [_c('v-textfield', {
    attrs: {
      "id": "username",
      "name": "username",
      "label": "Användarnamn",
      "tabindex": "1",
      "data-vv-value-path": "username",
      "validate": "required"
    },
    on: {
      "errors": _vm.onError
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _c('v-password', {
    attrs: {
      "id": "password",
      "name": "password",
      "tabindex": "2",
      "label": "Lösenord",
      "validate": "required"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)]), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit",
      "tabindex": "3"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Logga in")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-color-text--white"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("POSTAT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dfcb224","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 533
// module chunks = 1